"use strict";

const AssetRoutineMaintenanceCondition = function () {
  const stringKey = "condition";
  let $modalTab;
  let assetTypeConfig;

  var loadListeners = function (data) {
    $modalTab = $(`#assessment-modal #${stringKey}`);
    assetTypeConfig.inventoryDataHandler.loadListeners?.($modalTab, data);
    if (assetTypeConfig.capacityCalculationTaskKey) {
      $modalTab.on(
        "2N:FormInput",
        `[name^="structuralConditionIssues"], [name="total-depth"], [name="total-depth-unit"]`,
        renderCapacityRemaining,
      );
    }
    $modalTab.on("2N:FormInput", `.fieldset [type="radio"]`, toggleDropdowns);
    $modalTab.on(
      "2N:FormInput",
      `[name="condition-info[maintenance-needed]"]`,
      toggleSiblingFieldsets,
    );

    RoutineMaintenanceFormGeneral.setToggleInspectConditionFields(toggleInspectConditionFields);
    $modalTab.on("2N:FormInput", `[name="asset-accessible"]`, (e, isAccessible) =>
      RoutineMaintenanceFormGeneral.toggleAssetAccessible($modalTab, isAccessible),
    );
    RoutineMaintenanceFormGeneral.toggleAssetAccessible($modalTab, data.assetAccessible);

    $modalTab.on(
      "2N:FormInput",
      `[name="inspect-structural-condition-maintenance"]`,
      onToggleInspectStructuralConditionMaintenance,
    );
    if (data) {
      toggleInspectConditionFields(
        data.assetAccessible,
        data.inspectStructuralConditionMaintenance,
      );
    }

    RoutineMaintenanceFormTable.loadListeners($modalTab);
  };

  var unloadListeners = function () {
    RoutineMaintenanceFormGeneral.setToggleInspectConditionFields(null);
    $modalTab.off("2N:FormInput", `.fieldset [type="radio"]`);
    $modalTab.off("2N:FormInput", `[name="condition-info[maintenance-needed]"]`);
    $modalTab.off(
      "2N:FormInput",
      `[name^="structuralConditionIssues"], [name="total-depth"], [name="total-depth-unit"]`,
      renderCapacityRemaining,
    );
    assetTypeConfig.inventoryDataHandler.unloadListeners?.();
    RoutineMaintenanceFormTable.unloadListeners($modalTab);
  };

  var getProps = function (data) {
    assetTypeConfig = AssetTypeConfig.get(data.assetInfo.assetType);

    return {
      accessIssueOptions: DryWeatherConstants.getAccessIssueOptions(),
      trashRemovalVolumeUnitOptions: RoutineMaintenanceConstants.trashRemovalVolumeUnitOptions,
      damageDescriptionOptions: OutfallInspectionConstants.damageDescriptionOptions,
      cloggingMaterialOptions: OutfallInspectionConstants.cloggingMaterialOptions,
      stainsDescriptionOptions: OutfallInspectionConstants.stainsDescriptionOptions,
      vegetationGrowthDescriptionOptions:
        OutfallInspectionConstants.getVegetationGrowthDescriptionOptions(),
      biologicalGrowthDescriptionOptions:
        OutfallInspectionConstants.biologicalGrowthDescriptionOptions,
      activeErosionDescriptionOptions: OutfallInspectionConstants.activeErosionDescriptionOptions,
      inventoryDataTemplate: assetTypeConfig.inventoryDataTemplate,
      ...assetTypeConfig.inventoryDataHandler.getProps(data),
      ..._getCapacityProps(data, assetTypeConfig.capacityCalculationTaskKey),
    };
  };

  var _getCapacityProps = function (data, taskKey) {
    if (!taskKey) {
      return { showCapacityRemaining: false };
    }

    const capacityIssue = (data.structuralConditionIssues ?? []).find(
      (issue) => issue.key === taskKey,
    );
    const hasOpenCapacityIssue = (data.activeMaintenanceIssues ?? []).some(
      (issue) => issue.key === taskKey,
    );

    return {
      showCapacityRemaining: capacityIssue !== undefined || hasOpenCapacityIssue,
      totalRemainingCapacityPercentage: _getTotalRemainingCapacityPercentage(data, capacityIssue),
      capacityIssueCorrected:
        capacityIssue?.issue === true && capacityIssue.correction === "cleaned",
    };
  };

  var _getTotalRemainingCapacityPercentage = function (data, capacityIssue) {
    // The total depth is always in feet when returned from the DB, but it
    // can be other units if the user edits it during an inspection.
    const depth = data.totalDepth ?? data.assetInfo.inventoryData.totalDepth;
    const totalDepthFeet = UnitConversion.convertVal(
      Number(depth),
      data.totalDepthUnit ?? "feet",
      "feet",
    );

    if (!totalDepthFeet) {
      return null;
    }

    const ignoreIssueDepth =
      typeof capacityIssue?.dataNumber !== "number" || capacityIssue.issue === false;
    const capacityIssueDepthFeet = ignoreIssueDepth
      ? 0
      : UnitConversion.convertVal(capacityIssue.dataNumber, capacityIssue.dataOption, "feet");

    return Math.max(0, ((totalDepthFeet - capacityIssueDepthFeet) / totalDepthFeet) * 100);
  };

  var renderCapacityRemaining = function () {
    if (!$modalTab) {
      return;
    }

    const data = AssetRoutineMaintenanceController.getInspectionRenderData();
    const props = _getCapacityProps(data, assetTypeConfig.capacityCalculationTaskKey);
    const html = nunjucks.render("modals/routineMaintenance/sedimentTrashCapacitySection.njk", {
      props,
    });
    $modalTab.find(".sediment-trash-capacity-section").html(html);
  };

  var getStringKey = function () {
    return stringKey;
  };

  var getTabHeader = function () {
    return RoutineMaintenanceFormTable.getConditionTabName();
  };

  var toggleDropdowns = function (e, value) {
    const dropdowns = $(e.currentTarget).parents(".fieldset").find(".autonumeric, select");
    dropdowns.toggle(value);
  };

  var toggleSiblingFieldsets = function (e, value) {
    const siblingFields = $(e.currentTarget).parents("fieldset").siblings();
    siblingFields.toggleClass("hidden", !value);
  };

  var onToggleInspectStructuralConditionMaintenance = function (
    e,
    inspectStructuralConditionMaintenance,
  ) {
    toggleInspectConditionFields(null, inspectStructuralConditionMaintenance);
  };

  var toggleInspectConditionFields = function (
    assetAccessible = null,
    inspectStructuralConditionMaintenance = null,
  ) {
    if ($modalTab) {
      if (assetAccessible === null) {
        assetAccessible =
          AssetRoutineMaintenanceController.getInspectionRenderData()?.assetAccessible;
      }
      if (inspectStructuralConditionMaintenance === null) {
        inspectStructuralConditionMaintenance =
          AssetRoutineMaintenanceController.getInspectionRenderData()
            ?.inspectStructuralConditionMaintenance;
      }
      const showInspectConditionFields = assetAccessible && inspectStructuralConditionMaintenance;
      $modalTab.find(`.show-when-accessible-and-inspect`).toggle(showInspectConditionFields);

      const showWhenInspectStructuralConditionMaintenance = inspectStructuralConditionMaintenance;
      $modalTab
        .find(`.show-when-inspect-structural-condition-maintenance`)
        .toggle(showWhenInspectStructuralConditionMaintenance);
      TabbedModal.toggleTab("maintenance-repair", showWhenInspectStructuralConditionMaintenance);

      const $modal = $modalTab.closest(".modal-content");
      const hasNoAccessIssue = $modal.find(`[data-issue-key="asset-accessible"]`).length > 0;
      const noAccessIssueNotCorrected = $modal
        .find(`[data-issue-key="asset-accessible"][value="false"]`)
        .prop("checked");
      const hasNonCorrectedNoAccessIssue = hasNoAccessIssue && noAccessIssueNotCorrected;
      const showNoAccessMessage =
        inspectStructuralConditionMaintenance && hasNonCorrectedNoAccessIssue;
      $modalTab.find(`.no-access-message`).toggle(showNoAccessMessage);
    }
  };

  return {
    loadListeners,
    unloadListeners,
    getStringKey,
    getTabHeader,
    getProps,
    toggleInspectConditionFields,
    renderCapacityRemaining,
    _getCapacityProps,
  };
};

module.exports = AssetRoutineMaintenanceCondition();

const AssetRoutineMaintenanceController = require("./assetRoutineMaintenanceController");
const DryWeatherConstants = require("../../illicitDischarge/dryWeatherScreening/dryWeatherConstants");
const OutfallInspectionConstants = require("../../outfalls/outfallInspectionConstants");
const RoutineMaintenanceFormTable = require("../../general/routineMaintenanceFormTable");
const RoutineMaintenanceFormGeneral = require("../../general/routineMaintenanceFormGeneral");
const RoutineMaintenanceConstants = require("../../bmpfcs/routineMaintenanceConstants");
const TabbedModal = require("../../general/tabbedModal");
const AssetTypeConfig = require("./assetTypeConfig");
const UnitConversion = require("../../unitConversion");
